import { SwipeableDrawer } from "@mui/material";

const SideBarDrawer = ({ Edit, setEdit, children }) => {
  return (
    <>
      <SwipeableDrawer
        anchor={"right"}
        open={Edit.open ?? false}
        onClose={() =>
          setEdit({
            open: false,
            edit: "",
            title: "",
          })
        }
      >
        {children}
      </SwipeableDrawer>
    </>
  );
};

export default SideBarDrawer;
